import React from 'react'
import { DomainActivity } from './blocks/DomainActivity'
import {DomainActivityData} from "@/pages/buddy/types/DomainActivity.ts";

interface Props {
    data: DomainActivityData[]
    loading: boolean
}

export const DomainActivityContent: React.FC<Props> = ({ data, loading }) => (
    <div>
        <DomainActivity domains={data} loading={loading} />
    </div>
)
